import { onBeforeLanguageChange } from '@common/components/LanguageSwitcher/changeLanguage';
import { useEffect, useRef, useState } from 'react';
import {
  readWizardSnapshot,
  removeWizardSnapshot,
  saveWizardSnapshot,
  WizardSnapshot,
} from '../helpers/languageChangeSnapshot';

export const useRestoredLanguageChangeSnapshot = () => {
  const [snapshot, setSnapshot] = useState(readWizardSnapshot);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    removeWizardSnapshot();
    setHasMounted(true);
  }, []);

  return {
    snapshot,
    isRestoring: hasMounted && !!snapshot,
    clearSnapshot: () => setSnapshot(null),
  };
};

type SaveSnapshotOptions = {
  pendingSnapshot: WizardSnapshot | null;
  isPackageAddingOrAdded: boolean;
  getSnapshot: () => WizardSnapshot;
};

export const useSaveSnapshotOnLanguageChange = (options: SaveSnapshotOptions) => {
  const latestOptions = useRef(options);
  latestOptions.current = options;

  useEffect(
    () =>
      onBeforeLanguageChange(() => {
        const { pendingSnapshot, isPackageAddingOrAdded, getSnapshot } = latestOptions.current;
        if (pendingSnapshot) {
          saveWizardSnapshot(pendingSnapshot);
        } else if (!isPackageAddingOrAdded) {
          saveWizardSnapshot(getSnapshot());
        }
      }),
    []
  );
};
